<template>
  <label class="toggle">
    <input type="checkbox" v-model="checked" tabindex="0" />
    <div class="toggle__display" :class="{ buy: checked, sell: !checked }">
      <div class="toggle__background"></div>
      <div class="toggle__button toggle__button--buy">
        <p>Buy coins</p>
      </div>
      <div class="toggle__button toggle__button--sell">
        <p>Sell coins</p>
      </div>
    </div>
  </label>
</template>
<script setup>
import { computed } from "vue";
import { useOrderFormStore } from "@/stores/forms/orderFormStore";

const store = useOrderFormStore();

const checked = computed({
  get() {
    return store.isBuyMode;
  },
  set() {
    store.toggleBuySellMode();
  },
});
</script>
<style scoped lang="scss">
.toggle {
  width: 100%;
  display: block;
  cursor: pointer;
  margin-bottom: 3.2rem;

  input[type="checkbox"] {
    opacity: 0;
    position: absolute;
  }

  &__display {
    display: flex;
    border-radius: $border-radius;
    position: relative;
    overflow: hidden;
    background: var(--input-background);
  }

  &__button {
    width: 50%;
    padding: 2rem;
    text-align: center;
    position: relative;
    transition: opacity 250ms;

    &--buy {
      .sell & {
        opacity: 0.6;
      }
    }

    &--sell {
      .buy & {
        opacity: 0.6;
      }
    }

    p {
      font-weight: 500;
    }
  }

  &__background {
    width: 50%;
    height: 100%;
    position: absolute;
    background: var(--gradient);
    z-index: 0;
    transition: var(--toggle-background-transition);

    .buy & {
      transform: translateX(0);
    }

    .sell & {
      transform: translateX(100%);
    }
  }
}
</style>
